@if (documents$ | async; as documents) {
  <app-document-card
    cardTitle="Zur Bearbeitung (Buchhaltung)"
    [documents]="documents"
    [disableFilter]="true"
    [updateAccountingProcessedEnabled]="true"
    (searchValueChanged)="searchValue.next($event)"
    (editDocument)="editDocument($event)"
    (deleteDocument)="deleteDocument($event)"
  ></app-document-card>
}
